/* eslint-disable */
import React, { memo } from 'react';
import { StationCard } from '@widgets/StationCard';

const MemoizedStationCard = memo(
  ({ station, isFetching, closestPortsDeviceStatus, portCount = 1 }) => {
    return (
      <StationCard
        station={station}
        isFetching={isFetching}
        closestPortsDeviceStatus={closestPortsDeviceStatus}
        portCount={portCount}
      />
    );
  },
  (prevProps, nextProps) => {
    // Custom comparison function for better performance
    return (
      prevProps.station?.id === nextProps.station?.id &&
      prevProps.station?.name === nextProps.station?.name &&
      prevProps.station?.status === nextProps.station?.status &&
      prevProps.station?.online === nextProps.station?.online &&
      prevProps.station?.notesUa === nextProps.station?.notesUa &&
      prevProps.station?.notesEn === nextProps.station?.notesEn &&
      prevProps.station?.job?.state === nextProps.station?.job?.state &&
      prevProps.station?.job?.powerWt === nextProps.station?.job?.powerWt &&
      prevProps.station?.job?.leftS === nextProps.station?.job?.leftS &&
      prevProps.station?.deviceId === nextProps.station?.deviceId &&
      prevProps.isFetching === nextProps.isFetching &&
      prevProps.portCount === nextProps.portCount &&
      prevProps.closestPortsDeviceStatus === nextProps.closestPortsDeviceStatus
    );
  }
);

MemoizedStationCard.displayName = 'MemoizedStationCard';

export default MemoizedStationCard;
